import { IBaseResponse } from "@nkr/models/base-response";
import { IStrongBoxOpoFilter, IStrongBoxOpoUsageListing } from "@nkr/models/strong-box";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: IStrongBoxOpoUsageListing[],
    loading: boolean,
    error: string
}

function useStrongBoxOpoUsages(filter?: IStrongBoxOpoFilter): IRetVal {
    const { dispatch } = useAppHookContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IStrongBoxOpoUsageListing[]>([]);

    useEffect(() => {
        setError('');

        const fetchData = async () => {
            setLoading(true);

            let config = {
                url: `${__API__}/strongbox/opo/usage/search`,
                data: filter
            };

            try {

                const response: IBaseResponse = await dispatch(AuthActionCreators.apiPost(config));

                if (response && response.data.results && response.data.success) {
                    setList(response.data.results);
                } else {
                    setError('Unable to load data');
                    setList([]);
                }
            } catch (err) {
                setList([]);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        if (filter) fetchData();

    }, [filter]);

    return { loading, error, list };
}

export default useStrongBoxOpoUsages;
